import RiskQuestionnaire from "./RiskQuestionnaire";

export default RiskQuestionnaire;



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/model_portfolio/riskQuestionnaire/index.js